module.exports = __webpack_public_path__ + "img/BKCY1.e75883ec.jpg";